import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Module from "@/pages/Module";
import FinalExam from "@/pages/FinalExam";
import Certificate from "@/pages/Certificate";
import AdminDashboard from "@/pages/AdminDashboard";
import RangeBooking from "@/pages/RangeBooking";
import AdminRange from "@/pages/AdminRange";
import EmbedKit from "@/pages/EmbedKit";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/module/:id" element={<ProtectedRoute><Module /></ProtectedRoute>} />
            <Route path="/final-exam" element={<ProtectedRoute><FinalExam /></ProtectedRoute>} />
            <Route path="/certificate" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/range" element={<ProtectedRoute adminOnly><AdminRange /></ProtectedRoute>} />
            <Route path="/admin/embed" element={<ProtectedRoute adminOnly><EmbedKit /></ProtectedRoute>} />
            <Route path="/range" element={<ProtectedRoute><RangeBooking /></ProtectedRoute>} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
